<template>
  <div class="time-sheet">
    <CCard class="filter">
      <div class="filter-title">
        {{ $t("commons.label_filter_title") }}
      </div>
      <div class="filter_hr"></div>
      <div class="filter_content">
        <!-- <CCol col="12" sm="6" lg="4">
          <CRow class="py-2">
            <CCol col="12">
              <label>{{ $t("timeSheets.start_date") }}</label>
            </CCol>
            <CCol col="12">
              <DatePickerFormFlex
                :propsDate="searchData.start_date"
                @emitDate="startDate"
                v-model="searchData.start_date"
                v-on:keyup.enter="search"
              />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2">
            <CCol col="12">
              <label>{{ $t("timeSheets.end_date") }}</label>
            </CCol>
            <CCol col="12">
              <DatePickerFormFlex
                :propsDate="searchData.end_date"
                @emitDate="endDate"
                v-model="searchData.end_date"
                v-on:keyup.enter="search"
              />
            </CCol>
          </CRow>
        </CCol> -->
        <!-- <CCol col="12" sm="6" lg="3" class="filter_month"> -->
        <div class="filter_month">
          <div class="filter_month__title">
            {{ $t("commons.label_month") }}
          </div>
          <a-month-picker
            placeholder="MM/YYYY"
            size="large"
            :class="'month-picker__input'"
            v-model="searchData.month"
            :disabled-date="disableMonth"
            format="MM/YYYY"
            @change="search"
          >
            <template slot="suffixIcon">
              <img src="../../assets/img/calendar.svg" alt="" />
            </template>
          </a-month-picker>
        </div>
        <!-- </CCol> -->
        <!-- <CCol col="12" sm="6" lg="3" class="filter_month">
          <div>
            <div class="filter_month__title">ID/Họ và tên</div>
            <CInput
              type="text"
              :class="'month-picker__input'"
              v-model.trim="searchData.employee_info"
              v-on:keyup.enter="search"
            />
          </div>
        </CCol> -->
        <!-- <CCol col="12" sm="6" lg="3" class="filter_month"> -->
        <div class="filter_month">
          <div class="filter_month__title">{{ $t("timeSheets.id_name") }}</div>
          <CInput
            type="text"
            v-model="searchData.employee_info"
            v-on:keyup.enter="search"
          />
          <!-- </CCol> -->
        </div>
        <div class="filter_month">
          <div class="filter_month__title">
            {{ $t("label.member_companies") }}
          </div>
          <select
            class="form-control form-group"
            v-model="searchData.company_code"
            @change="search"
          >
            <option value="0">
              {{ $t("placeholder.label_employee_option_search") }}
            </option>
            <option
              v-for="(company, index) in companies"
              :key="index"
              :value="index"
            >
              {{ company.name }}
            </option>
          </select>
        </div>
        <div class="filter_month">
          <div class="filter_month__title">Foot</div>
          <select
            class="form-control form-group"
            v-model="searchData.foot_code"
            @change="search"
          >
            <option value="0">
              {{ $t("placeholder.label_employee_option_search") }}
            </option>
            <option v-for="foot in foots" :key="foot.id" :value="foot.code">
              {{ foot.name }}
            </option>
          </select>
        </div>
        <div class="filter_month">
          <div class="filter_month__title">{{ $t("label.division") }}</div>
          <select
            class="form-control form-group"
            v-model="searchData.division_code"
            @change="search"
          >
            <option value="0">
              {{ $t("placeholder.label_employee_option_search") }}
            </option>
            <option
              v-for="division in filterDivision"
              :key="division.id"
              :value="division.code"
            >
              {{ division.name }}
            </option>
          </select>
        </div>
      </div>
      <CRow>
        <CCol sm="12" lg="12" md="12" col="12" class="px-0 text-center">
          <CButton @click="search" class="btn-search-timesheet mr-2">
            <img src="/img/icons/search-icon.svg" alt="" />
            {{ $t("label.search") }}
          </CButton>
        </CCol>
      </CRow>
      <!-- <CRow class="justify-content-center btn-search-mb">
        <CButton @click="search" class="btn-search-timesheet"
          >{{ $t("label.search") }}
        </CButton>
        <CButton class="btn-reset" @click="resetForm"
          >{{ $t("button.label_action_reset") }}
        </CButton>
      </CRow> -->
    </CCard>
    <div class="table-list">
      <CCard>
        <CCardBody>
          <!-- <CRow class="justify-content-end p-2 mb-md-0 mb-3">
            <CButton color="info mr-3" @click="importTimesheet">Import</CButton>
            <CButton color="warning ml-3" @click="exportData">Export</CButton>
          </CRow> -->
          <div class="option-table">
            <div class="page-title">
              {{ $t("page_title.page_timesheet_list") }} ({{
                searchData.paginate.totalRecord
              }})
              <!-- <select
                class="form-control"
                v-model="searchData.itemsPerPage"
                @change="search"
              >
                <option
                  v-for="item in listItemsPerPage"
                  :value="item"
                  :key="item"
                >
                  {{ item }}
                </option>
              </select> -->
            </div>
            <div class="excel-option">
              <CButton class="excel-btn import-btn" @click="importTimesheet"
                >Import</CButton
              >
              <CButton class="excel-btn export-btn" @click="exportData">
                <img
                  src="/img/icons/excel-export-icon.svg"
                  class="mr-1"
                  alt=""
                />Export</CButton
              >
            </div>
            <!-- <template v-if="timeSheets.data && timeSheets.data.length > 0">
              <div class="show-text-table">
                {{ $t("commons.label_text_show") }}
                {{ searchData.paginate.from }}
                {{ $t("commons.label_text_to") }} {{ searchData.paginate.to }}
                {{ $t("commons.label_text_of") }}
                {{ searchData.paginate.totalRecord }}
                {{ $t("commons.label_text_entries") }}
              </div>
            </template>
            <template v-else>
              <div class="show-text-table">
                {{ $t("commons.label_text_show") }}
                {{ searchData.paginate.from }}
                {{ searchData.paginate.to }}
                {{ searchData.paginate.totalRecord }}
                {{ $t("commons.label_text_entries") }}
              </div>
            </template> -->
          </div>
          <div class="table-responsive table-ecs-container">
            <table class="table-content table-hover">
              <thead class="table-header">
                <tr>
                  <th>#</th>
                  <th class="employee-code">{{ $t("label.employee_code") }}</th>
                  <th>{{ $t("label.full_name") }}</th>
                  <th>Foot</th>
                  <th>{{ $t("label.division") }}</th>
                  <th class="employee-total">{{ $t("timeSheets.date") }}</th>
                  <!-- <th>{{ $t("timeSheets.day_of_week") }}</th> -->
                  <th>{{ $t("timeSheets.checkin_time") }}</th>
                  <th>{{ $t("timeSheets.checkout_time") }}</th>
                  <!-- <th>{{ $t("timeSheets.work_time_real") }}</th> -->
                  <!-- <th>{{ $t("timeSheets.work_time_pay") }}</th> -->
                  <th>{{ $t("timeSheets.work_time_nomal") }}</th>
                  <th class="employee-total">
                    {{ $t("timeSheets.work_time_OT") }}
                  </th>
                  <th class="employee-total">
                    {{ $t("timeSheets.work_time_total") }}
                  </th>
                  <th class="employee-detail">{{ $t("timeSheets.note") }}</th>
                  <th>{{ $t("label.action") }}</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <template v-if="timeSheets.data && timeSheets.data.length > 0">
                  <tr
                    v-for="(timeSheet, index) in timeSheets.data"
                    :key="timeSheet.id"
                    :class="classDayOff(timeSheet.day_off_user)"
                  >
                    <td class="table-index">
                      {{
                        (timeSheets.current_page - 1) * timeSheets.per_page +
                        index +
                        1
                      }}
                    </td>
                    <td>{{ timeSheet.employee_id }}</td>
                    <td>{{ timeSheet.employee_name }}</td>
                    <td>{{ timeSheet.foot }}</td>
                    <td>{{ timeSheet.division }}</td>
                    <td>
                      <div class="text-center">
                        <div>
                          {{ timeSheet.work_date }}
                        </div>
                        <div>
                          {{ $t(`timeSheets.${timeSheet.day_of_week}`) }}
                        </div>
                      </div>
                      <!-- {{ timeSheet.work_date }}</td> -->
                      <!-- <td>{{ $t(`timeSheets.${timeSheet.day_of_week}`) }}</td> -->
                    </td>

                    <td>
                      <span
                        v-if="timeSheet.start_time_real"
                        class="employee__badge"
                      >
                        <img
                          :class="
                            timeSheet.start_time_real > timeSheet.start_time_pay
                              ? 'img__higher'
                              : 'img__lower'
                          "
                          src="../../assets/icons/clock.svg"
                          alt=""
                        />
                        <span
                          :class="
                            timeSheet.start_time_real > timeSheet.start_time_pay
                              ? 'span__higher'
                              : 'span__lower'
                          "
                        >
                          {{ timeSheet.start_time_real }}
                        </span>
                      </span>
                      <div v-else>-</div>
                    </td>
                    <td>
                      <span
                        v-if="timeSheet.end_time_real"
                        class="employee__badge"
                      >
                        <img
                          :class="
                            timeSheet.end_time_real < timeSheet.end_time_pay
                              ? 'img__higher'
                              : 'img__lower'
                          "
                          src="../../assets/icons/clock.svg"
                          alt=""
                        />
                        <span
                          :class="
                            timeSheet.end_time_real < timeSheet.end_time_pay
                              ? 'span__higher'
                              : 'span__lower'
                          "
                        >
                          {{ timeSheet.end_time_real }}
                        </span>
                      </span>
                      <div v-else>-</div>
                    </td>
                    <!-- <td>
                      {{
                        timeSheet.work_time_real
                          ? timeSheet.work_time_real
                          : "-"
                      }}
                    </td> -->
                    <td>
                      <span
                        v-if="
                          timeSheet.work_time_pay_summary &&
                          timeSheet.work_time_pay_summary != '00:00'
                        "
                        :class="classTimePay(timeSheet.work_time_pay_summary)"
                      >
                        {{ timeSheet.work_time_pay_summary }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <span
                        v-if="timeSheet.ot_150 && timeSheet.ot_150 !== '00:00'"
                      >
                        {{ `${timeSheet.ot_150} x 150%` }}
                      </span>
                      <span
                        v-else-if="
                          timeSheet.ot_200 && timeSheet.ot_200 !== '00:00'
                        "
                      >
                        {{ `${timeSheet.ot_200} x 200%` }}
                      </span>
                      <span v-else> - </span>
                    </td>
                    <td>
                      {{
                        (timeSheet.all_time)
                          ? timeSheet.all_time
                          : "-"
                      }}
                    </td>
                    <td>
                      <div
                        v-if="timeSheet.day_off_user == 3"
                        class="employee__holiday-off"
                      >
                        {{ $t(`commons.label_compensation_holiday`) }}
                      </div>
                      <div
                        v-if="timeSheet.day_off_user == 2"
                        class="employee__holiday-off"
                      >
                        {{ $t(`commons.label_holiday_off`) }}
                      </div>
                      <div
                        v-if="timeSheet.day_off_user == 1"
                        class="employee__dayoff"
                      >
                        {{ $t(`commons.label_weekend`) }}
                      </div>
                      <div
                        v-if="
                          timeSheet.late_pay &&
                          calculateEarlyLateTime(
                            timeSheet.late_pay,
                            timeSheet.compensation_leave
                          ) != '00:00' &&
                          timeSheet.day_off_user == 0 &&
                          timeSheet.work_time_pay &&
                          timeSheet.work_time_pay != '00:00'
                        "
                        class="employee__leave"
                      >
                        {{ $t("timeSheets.late_time") }}:
                        {{
                          calculateEarlyLateTime(
                            timeSheet.late_pay,
                            timeSheet.compensation_leave
                          )
                        }}
                      </div>
                      <div
                        v-if="
                          timeSheet.early_pay &&
                          calculateEarlyLateTime(
                            timeSheet.early_pay,
                            timeSheet.compensation_leave
                          ) != '00:00' &&
                          timeSheet.day_off_user == 0 &&
                          timeSheet.day_off_user == 0 &&
                          timeSheet.work_time_pay &&
                          timeSheet.work_time_pay != '00:00'
                        "
                        class="employee__leave"
                      >
                        {{ $t("timeSheets.early_time") }}:
                        {{
                          calculateEarlyLateTime(
                            timeSheet.early_pay,
                            timeSheet.compensation_leave
                          )
                        }}
                      </div>
                      <div
                        v-if="
                          timeSheet.paid_leave_time &&
                          timeSheet.day_off_user == 0
                        "
                        class="employee__dayoff"
                      >
                        {{ $t("timeSheets.paid_leave") }}:
                        {{ timeSheet.paid_leave_time }}
                      </div>
                      <!-- <div v-if="timeSheet.ot_time_real">
                        - {{ $t("timeSheets.ot_time_real") }}:
                        {{ timeSheet.ot_time_real }}
                      </div> -->
                      <!-- <div v-if="timeSheet.ot_time_real">
                        - {{ $t("timeSheets.ot_time_minus_late_early") }}:
                        {{
                          timeSheet.ot_time_minus_late_early
                            ? timeSheet.ot_time_minus_late_early
                            : "00:00"
                        }}
                      </div>
                      <div v-if="timeSheet.ot_150">
                        - {{ $t("timeSheets.ot_150_percent") }}:
                        {{ timeSheet.ot_150 }}
                      </div>
                      <div v-if="timeSheet.ot_200">
                        - {{ $t("timeSheets.ot_200_percent") }}:
                        {{ timeSheet.ot_200 }}
                      </div> -->
                      <div
                        v-if="
                          timeSheet.compensation_leave &&
                          timeSheet.day_off_user == 0
                        "
                        class="employee__dayoff"
                      >
                        {{
                          $t(`commons.label_status_sabbatical_leave_type_1`)
                        }}: {{ timeSheet.compensation_leave }}
                      </div>
                      <div
                        v-if="
                          timeSheet.paid_leave && timeSheet.day_off_user == 0
                        "
                        class="employee__dayoff"
                      >
                        {{
                          $t(`commons.label_status_sabbatical_leave_type_2`)
                        }}: {{ timeSheet.paid_leave }}
                      </div>
                      <div
                        v-if="
                          timeSheet.unpaid_leave && timeSheet.day_off_user == 0
                        "
                        class="employee__leave"
                      >
                        {{
                          $t(`commons.label_status_sabbatical_leave_type_3`)
                        }}: {{ timeSheet.unpaid_leave }}
                      </div>
                      <div
                        v-if="
                          timeSheet.physiological_leave_minute
                        "
                        class="employee__leave"
                      >
                        {{
                          $t(`detail_employee_timesheet.label.physiological`)
                        }}: {{ timeSheet.physiological_leave_minute }} {{$t(`detail_employee_timesheet.label.date`)}}
                      </div>
                      <div
                        v-if="
                          !timeSheet.late_pay &&
                          !timeSheet.early_pay &&
                          !timeSheet.paid_leave_time &&
                          !timeSheet.ot_time &&
                          !timeSheet.ot_time_minus_late_early &&
                          !timeSheet.ot_time &&
                          !timeSheet.ot_150 &&
                          !timeSheet.ot_200 &&
                          !timeSheet.ot_time_real &&
                          !timeSheet.ot_time_minus_late_early &&
                          !timeSheet.paid_leave &&
                          !timeSheet.compensation_leave &&
                          !timeSheet.unpaid_leave &&
                          timeSheet.day_off_user == 0
                        "
                      >
                        -
                      </div>
                    </td>
                    <td>
                      <CButton
                        class="btn btn-outline-edit"
                        square
                        size="sm"
                        @click="showFormUpdate(timeSheet)"
                        >{{ $t("button.label_action_edit") }}
                      </CButton>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="13" class="text-center">
                      {{ $t("table.label_data_not_found") }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </CCardBody>
        <CPagination
          v-if="timeSheets.data && timeSheets.data.length > 0"
          :activePage.sync="searchData.paginate.currentPage"
          :pages="searchData.paginate.totalPage"
          @update:activePage="fetchTimeSheetData"
          size="sm"
          align="center"
        />
      </CCard>
    </div>
    <template>
      <b-modal
        size="lg"
        ref="my-modal"
        :title="$t('label.update_timesheet')"
        hide-footer
      >
        <ValidationObserver ref="updateDataTimeSheet" v-slot="{ handleSubmit }">
          <CForm @submit.prevent="handleSubmit(updateDataTimeSheet)">
            <CRow class="mb-6">
              <CCol sm="12">
                <CRow>
                  <CCol sm="12" xl="2">
                    <label>{{ $t("label.date") }}</label>
                  </CCol>
                  <CCol sm="12" xl="4">
                    <CInput
                      type="text"
                      readonly
                      v-model="timeSheetUpdate.work_date"
                    />
                  </CCol>
                </CRow>
              </CCol>
              <CCol md="6" sm="12">
                <CRow>
                  <CCol sm="12" xl="4">
                    <label>{{ $t("label.employee_code") }}</label>
                  </CCol>
                  <CCol sm="12" xl="8">
                    <CInput
                      type="text"
                      readonly
                      v-model="timeSheetUpdate.employee_id"
                    />
                  </CCol>
                </CRow>
              </CCol>
              <CCol md="6" sm="12">
                <CRow>
                  <CCol sm="12" xl="4">
                    <label>{{ $t("label.full_name") }}</label>
                  </CCol>
                  <CCol sm="12" xl="8">
                    <CInput
                      type="text"
                      readonly
                      v-model="timeSheetUpdate.employee_name"
                    />
                  </CCol>
                </CRow>
              </CCol>
              <CCol md="6" sm="12">
                <CRow>
                  <CCol sm="12" xl="4">
                    <label>
                      {{ $t("label.start_time") }}
                      <span class="required">*</span>
                    </label>
                  </CCol>
                  <CCol sm="12" xl="8">
                    <ValidationProvider
                      rules="required|max:20"
                      v-slot="{ errors }"
                      :name="$t('label.start_time')"
                    >
                      <b-form-input
                        class="form-group mb-mobile-0"
                        type="text"
                        v-mask="'##:##'"
                        placeholder="HH:ii"
                        v-model="timeSheetUpdate.start_time_real"
                      />
                      <span class="error-required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>
              </CCol>
              <CCol md="6" sm="12">
                <CRow>
                  <CCol sm="12" xl="4">
                    <label>
                      {{ $t("label.end_time") }}
                      <span class="required">*</span>
                    </label>
                  </CCol>
                  <CCol sm="12" xl="8">
                    <ValidationProvider
                      rules="required|max:20"
                      v-slot="{ errors }"
                      :name="$t('label.end_time')"
                    >
                      <b-form-input
                        class="form-group mb-mobile-0"
                        type="text"
                        v-mask="'##:##'"
                        placeholder="HH:ii"
                        v-model="timeSheetUpdate.end_time_real"
                      />
                      <span class="error-required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            <CRow class="d-flex justify-content-end mr-auto">
              <b-button type="submit" class="btn btn-success mt-3">
                {{ $t("label.save_infomation") }}
              </b-button>
              <span class="mr-2"></span>
              <b-button class="mt-3" variant="outline-danger" @click="hideModal"
                >{{ $t("popup.timesheet.label_cancel_button") }}
              </b-button>
            </CRow>
          </CForm>
        </ValidationObserver>
      </b-modal>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import XLSX from "xlsx";
import "sweetalert2/src/sweetalert2.scss";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import DatePickerFormFlex from "@/components/Common/DatePickerFormFlex";
import moment from "moment";

export default {
  name: "TimeSheetList",
  metaInfo() {
    return {
      title: this.$t("page_title.page_timesheet_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    DatePickerFormFlex,
  },
  data() {
    return {
      timeSheetUpdate: {},
      searchData: {
        // start_date: "",
        // end_date: "",
        month: moment(),
        company_code: "0",
        foot_code: "0",
        division_code: "0",
        employee_info: "",
        itemsPerPage: 10,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0,
        },
      },
      export: true,
    };
  },
  created() {
    // this.searchData.start_date = this.getDateSearch().firstDay;
    // this.searchData.end_date = this.getDateSearch().lastDay;
    // this.searchData.month = moment()
    this.$route.query ? this.fillDataFilterTimeSheet(this.$route.query) : "";
    this.fetchTimeSheetData();
  },
  computed: {
    ...mapGetters({
      timeSheets: "timeSheet/timeSheets",
      timeSheetsExport: "timeSheet/timeSheetsExport",
      pagination: "timeSheet/pagination",
      companies: "commons/companies",
      foots: "commons/foots",
      divisions: "commons/divisions",
      listItemsPerPage: "commons/listItemsPerPage",
    }),
    filterDivision() {
      if (this.searchData.foot_code === "0") return this.divisions;
      return this.divisions.filter(
        (division) => division.parent_code === this.searchData.foot_code
      );
    },
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    fillDataFilterTimeSheet(query) {
      let endDate = this.getDateSearch().lastDay;
      if (query.month) {
        const date = moment(query.month, "MM/YYYY");
        const month = date.format("MM");
        const year = date.format("YYYY");
        endDate = moment(`${year}-${month}-01`)
          .endOf("month")
          .format("DD/MM/YYYY");
      }
      query.foot === 0 ||
      query.foot === 0 ||
      this.foots.filter((foot) => foot.code === query.foot).length <= 0
        ? (this.searchData.foot_code = "0")
        : (this.searchData.foot_code = query.foot);
      query.division ||
      query.division === 0 ||
      this.divisions.filter((foot) => foot.code === query.division).length <= 0
        ? (this.searchData.division_code = "0")
        : (this.searchData.division_code = query.division);
      this.searchData.division_code = query.division
        ? query.division
        : this.searchData.division_code;
      this.searchData.employee_info = query.id;
      // this.searchData.start_date = query.month ? `01/${query.month}` : this.getDateSearch().firstDay;
      // this.searchData.end_date = endDate;
      this.searchData.start_date = query.month
        ? moment(query.month, "MM/YYYY").startOf("month").format("DD/MM/YYYY")
        : moment().startOf("month").format("DD/MM/YYYY");
      this.searchData.end_date = query.month
        ? moment(query.month, "MM/YYYY").endOf("month").format("DD/MM/YYYY")
        : moment().endOf("month").format("DD/MM/YYYY");
    },
    // startDate(data) {
    //   this.searchData.start_date = data;
    // },

    // endDate(data) {
    //   this.searchData.end_date = data;
    // },
    disableMonth(current) {
      return current && current > moment().endOf("day");
    },

    resetForm() {
      //   this.searchData.start_date = this.getDateSearch().firstDay;
      //   this.searchData.end_date = this.getDateSearch().lastDay;
      this.searchData.month = moment();
      this.searchData.company_code = "0";
      this.searchData.foot_code = "0";
      this.searchData.division_code = "0";
      this.searchData.employee_info = "";
    },

    async fetchTimeSheetData() {
      await this.$store.dispatch("timeSheet/fetchTimeSheet", {
        start_date: moment(this.searchData.month)
          .startOf("month")
          .format("DD/MM/YYYY"),
        end_date: moment(this.searchData.month)
          .endOf("month")
          .format("DD/MM/YYYY"),
        foot_code: this.searchData.foot_code,
        division_code: this.searchData.division_code,
        company_code: this.searchData.company_code,
        employee_info: this.searchData.employee_info,
        itemsPerPage: this.searchData.itemsPerPage,
        currentPage: this.searchData.paginate.currentPage,
      });
      this.searchData.paginate = this.pagination;
    },
    async exportData() {
      this.setLoading(true);
      await this.$store
        .dispatch("timeSheet/fetchTimeSheetsExport", {
          start_date: moment(this.searchData.month)
            .startOf("month")
            .format("DD/MM/YYYY"),
          end_date: moment(this.searchData.month)
            .endOf("month")
            .format("DD/MM/YYYY"),
          foot_code: this.searchData.foot_code,
          division_code: this.searchData.division_code,
          company_code: this.searchData.company_code,
          employee_info: this.searchData.employee_info,
          export: this.export,
        })
        .then(() => {
          this.setLoading(false);
          this.$toast(
            this.$t("popup.label_popup_export_success"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
        })
        .catch(() => {
          this.setLoading(false);
        });
      let Heading = [
        [
          "Mã nhân viên",
          "Họ và tên",
          "Ngày",
          "Thứ",
          "Vào lúc",
          "Ra lúc",
          "Giờ bắt đầu tính công",
          "Giờ kết thúc tính công",
          "Đi muộn",
          "Về sớm",
          "OT 150%",
          "OT 200%",
          "Nghỉ bù phép",
          "Nghỉ việc riêng hưởng lương",
          "Nghỉ không lương",
          "Giờ công thực tế",
          "Giờ công tính lương",
        ],
      ];
      var ws = XLSX.utils.aoa_to_sheet(Heading);
      let dataExport = this.timeSheetsExport.data;
      for (var key in dataExport) {
        let dayOfWeek = dataExport[key]["day_of_week"].toLowerCase();
        dataExport[key]["day_of_week"] = this.$t("timeSheets." + dayOfWeek);
      }
      ws = XLSX.utils.sheet_add_json(ws, dataExport, {
        skipHeader: true,
        origin: "A2",
      });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Chi tiết công số");
      XLSX.writeFile(
        wb,
        "Chi tiết công số_" +
          Date.now() +
          "_" +
          moment(this.searchData.month).startOf("month").format("DD/MM/YYYY") +
          "-" +
          moment(this.searchData.month).endOf("month").format("DD/MM/YYYY") +
          ".xlsx"
      );
    },
    async search() {
      if (this.$route.query.length > 0) {
        const query = Object.assign({}, this.$route.query);
        delete query.id;
        delete query.month;
        delete query.foot;
        delete query.division;
        this.$router.replace({ query });
      }
      this.searchData.paginate.currentPage = 1;
      this.setLoading(true);
      try {
        await this.fetchTimeSheetData();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },
    getDateSearch() {
      let date = new Date();
      let currentDay = moment(date).format("YYYY-MM-DD");
      let firstDay = "";
      if (
        moment(new Date(date.getFullYear(), date.getMonth(), 1)).format(
          "YYYY-MM-DD"
        ) <= currentDay &&
        currentDay <=
          moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
            "YYYY-MM-DD"
          )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
      }
      if (
        currentDay >
        moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
          "YYYY-MM-DD"
        )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      }
      return {
        firstDay: Intl.DateTimeFormat("en-GB").format(firstDay),
        lastDay: "",
      };
    },
    importTimesheet() {
      this.$router.push({ name: "time-sheets.import" });
    },
    showFormUpdate(timeSheet) {
      this.$refs["my-modal"].show();
      let cloneTimeSheet = {};
      cloneTimeSheet.id = timeSheet.id;
      cloneTimeSheet.work_date = timeSheet.work_date;
      cloneTimeSheet.employee_id = timeSheet.employee_id;
      cloneTimeSheet.employee_name = timeSheet.employee_name;
      cloneTimeSheet.start_time_real = timeSheet.start_time_real;
      cloneTimeSheet.end_time_real = timeSheet.end_time_real;
      this.timeSheetUpdate = cloneTimeSheet;
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    async updateDataTimeSheet() {
      this.setLoading(true);
      await this.$store
        .dispatch("timeSheet/updateTimeSheet", this.timeSheetUpdate)
        .then(() => {
          this.setLoading(false);
          this.hideModal();
          this.fetchTimeSheetData();
          this.$toast(
            this.$t("popup.timesheet.label_popup_update_success"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
    classTimePay(data) {
      let result = "";
      if (data && data < "08:00") {
        result = "span__higher";
      }
      if (data && data > "08:00") {
        return "span__lower";
      }
      return result;
    },
    classDayOff(data) {
      if (data === 1) {
        return "day-off";
      } else if (data === 2 || data === 3) {
        return "holiday-off";
      }
    },
    sumWorkTime(work_time, ot_time) {
      const realWorkTime = moment(work_time, "HH:mm")
        // .subtract(moment.duration({ hours: 1, minutes: 30 }))
        .format("HH:mm");
      var workTime = moment.duration(realWorkTime);

      // subtract rounding error
      if (work_time == "08:01") {
        workTime = workTime.subtract(moment.duration({ minutes: 1 }));
      }
      if (work_time == "08:02") {
        workTime = workTime.subtract(moment.duration({ minutes: 2 }));
      }

      const realOtTime = moment.duration(ot_time);
      const totalTime = workTime.add(realOtTime);

      let hours =
        totalTime.hours() < 10 ? `0${totalTime.hours()}` : totalTime.hours();
      let minutes =
        totalTime.minutes() < 10
          ? `0${totalTime.minutes()}`
          : totalTime.minutes();
      return `${hours}:${minutes}`;
    },
    calculateEarlyLateTime(earlyLateHour, sabbaticalDay) {
      if (sabbaticalDay <= 0.5 && earlyLateHour >= "04:00") {
        const sabbaticalSec = sabbaticalDay * 8 * 60 * 60;
        const earlyLateDuration = moment.duration(earlyLateHour);
        let sabbticalDuration = moment.duration(sabbaticalSec, "seconds");
        const result = earlyLateDuration.subtract(sabbticalDuration);
        let hours = result.hours() < 10 ? `0${result.hours()}` : result.hours();
        let minutes =
          result.minutes() < 10 ? `0${result.minutes()}` : result.minutes();
        return `${hours}:${minutes}`;
      }
      return earlyLateHour;
    },
  },
};
</script>

<style scoped>
.table-list {
  margin: 12px -24px 0 -24px;
}

/* tr.day-off {
  background-color: #f0f8ff;
} */

th,
td {
  vertical-align: middle !important;
}

.required,
.error-required {
  color: #dc1313;
  font-size: 13px;
}

/* .option-table {
  display: flex;
  justify-content: space-between;
} */

.btn-search-timesheet {
  background-color: #b5dbf2;
  padding: 8px;
  width: 120px;
}

.btn:focus,
.btn.focus {
  box-shadow: none !important;
}

@media only screen and (max-device-width: 767px) {
  .show-text-table {
    margin-left: 2.375rem;
  }

  .py-mobile-0 {
    padding: 0 !important;
  }

  .btn-search-mb {
    margin-top: 15px;
  }

  .table-mobile {
    width: 1200px;
    overflow-x: scroll;
  }

  .mb-mobile-0 {
    margin-bottom: 0;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .table-mobile {
    width: 1200px;
    overflow-x: scroll;
  }
}
</style>
 <style lang="scss" scoped>
.time-sheet {
  margin: 12px -6px 0 -6px;
.card {
  border: unset;
  border-radius: unset;

  &-body {
    padding: 10px 24px 0 24px;
  }
}
  .filter {
    /* margin: -2rem -2rem 0rem -2rem;
  padding: 2rem; */
    margin: -2rem -24px 0 -24px;
    padding: 19px 24px;
    @media only screen and (max-device-width: 1024px) {
      margin-left: -10px;
      margin-right: -10px;
    }
  }
  .filter-title {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #3d4cdc;
  }
  .filter_hr {
    width: 100%;
    height: 1px;
    background-color: #eaeaea;
    margin: 19px 0;
  }
  .filter_content {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    gap: 10px;
    .filter_month {
      width: 100%;
    }
    @media screen and (max-width: 1200px) {
      grid-template-columns: 1fr 1fr 1fr;
    }
    @media screen and (max-width: 480px) {
      grid-template-columns: 1fr 1fr;
    }
  }
  .filter_month__title {
    font-size: 14px;
    line-height: 17px;
    color: #303c54;
    font-weight: 500;
    margin-bottom: 8px;
  }
  .btn-search-timesheet {
    margin-top: 25px;
    height: 40px;
    width: 100%;
    max-width: 210px;

    background: #3d4cdc;
    border-radius: 10px;
    font-weight: 700;
    font-size: 14px;
    color: #ffffff;
  }
  .option-table {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .page-title {
      font-weight: 700;
      font-size: 18px;
      color: #3d4cdc;
    }
  }

  .excel-option {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 14px;

    .excel-btn {
      font-size: 14px;
      font-weight: 700;
      border-radius: 10px;
      width: 210px;
      margin-left: 20px;
      @media screen and (max-width: 768px) {
        width: 150px;
      }
      @media screen and (max-width: 480px) {
        width: 95px;
      }
    }
    .import-btn {
      background: #3d4cdc;
      color: white;
    }

    .export-btn {
      background: #f58722;
      color: white;
    }
  }
  .table-ecs-container {
    border-radius: 10px 10px 0 0;
    overflow-x: auto;
    border: 1px solid #efefef;
    table-layout: auto;
    .table-content {
      min-width: 1130px;
      width: 100%;
      min-height: 170px;
      .table-header {
        tr {
          // border-top: 1px solid #fff;
          border-bottom: 1px solid #fff;
          th {
            padding: 15px 0px;
            min-width: 100px;
            background-color: #3488eb;
            border-right: 1px solid #fff;
            color: #fff;
            text-align: center;
          }
          th:first-child {
            min-width: 40px;
          }
          th.employee-code {
            min-width: 55px;
          }
          th.employee-total {
            min-width: 90px;
          }
          th.employee-detail {
            min-width: 120px;
          }
        }
      }
      .table-body {
        tr {
          td {
            padding: 15px 3px;
            border: 1px solid #efefef;
            text-align: -webkit-center;
          }
          td:first-child {
            border-left: none;
          }
          td:last-child {
            border-right: none;
          }
        }
        tr:last-child {
          td {
            border-bottom: none;
          }
        }
        .table-index {
          font-weight: bold;
        }
      }
      .btn-outline-edit {
        color: #3488eb;
        border: 1px solid #3488eb;
      }

      .btn-outline-edit:hover {
        color: #ffffff;
        background: #3488eb;
        border: 1px solid #3488eb;
      }
      .employee__badge {
        background: #eff2f7;
        border-radius: 73px;
        padding: 4px 10px;
        font-weight: 700;
      }
      .img__higher {
        filter: brightness(0) saturate(100%) invert(70%) sepia(52%)
          saturate(4593%) hue-rotate(347deg) brightness(101%) contrast(92%);
      }
      .day-off {
        background-color: #fff4e4;
        // background-color: #f0f8ff;
      }
      .holiday-off {
        background-color: rgba(223, 49, 91, 0.1);
      }

      .employee__dayoff {
        color: #1190a6;
        font-weight: 700;
      }

      .employee__work {
        color: #0fa868;
        font-weight: 700;
      }

      .employee__holiday-off {
        color: #df315b;
        font-weight: 700;
      }

      .employee__leave {
        color: #f58722;
        font-weight: 700;
      }

      .span__higher {
        color: #f58722;
        font-weight: 700;
      }
      .span__lower {
        color: #0fa868;
        font-weight: 700;
      }
    }
  }
}
</style>
<style lang="scss">
.time-sheet {
  .ant-calendar-picker {
    width: 100%;

    .ant-input {
      border-radius: 10px !important;
      width: 100%;
    }
  }
  input,
  select {
    border-radius: 10px !important;
    width: 100%;
    height: 40px;
  }
}
</style>
